module.exports = __webpack_public_path__ + "static/media/dine_in_protocols.6d719425.jpg";